import { useEffect, useState } from "react";

import useTimeoutFn from "react-use/lib/useTimeoutFn";

function useDebounceStatus(
  currentStatus: "error" | "idle" | "loading" | "success" = "idle",
  ms = 2000,
) {
  const [status, setStatus] = useState(currentStatus);

  const [, cancel, reset] = useTimeoutFn(() => {
    setStatus(currentStatus);
  }, ms);

  useEffect(() => {
    switch (currentStatus) {
      case "success":
      case "error": {
        reset();
        break;
      }

      default: {
        cancel();

        setStatus(currentStatus);

        break;
      }
    }
  }, [currentStatus]);

  return status;
}

export { useDebounceStatus };
